module.exports = __webpack_public_path__ + "static/media/jean-paul-sponsor.1139213d.png";